<template>
    <component :is="smiley" :active="this.score !== null"></component>
</template>

<script>
import Loving from './smileys/Loving.vue';
import Hating from './smileys/Hating.vue';
import Grinning from './smileys/Grinning.vue';
import Smiling from './smileys/Smiling.vue';
import Doubting from './smileys/Doubting.vue';
import NoScore from "./smileys/NoScore.vue";

export default {
    components: {
        'rating-100': Loving,
        'rating-80': Grinning,
        'rating-60': Smiling,
        'rating-40': Doubting,
        'rating-20': Hating,
        'rating-0': NoScore,
    },
    props: {
        score: {
            required: true,
            validator: value => typeof value === 'number' || value === null,
        }
    },
    computed: {
        smiley() {
            if (this.score === null) {
                return 'rating-0';
            }

            return 'rating-' + Math.ceil(Math.max(1, this.score / 20)) * 20;
        }
    },
}
</script>
